/*Klaviyo BIS script starts */
var klaviyo = klaviyo || [];
    klaviyo.init({
      account: "cJiQcN",
      list: 'KsE5KP',
      platform: "shopify",
      exclude_on_tags: 'plus-delivery, Gooten,shipping-protection,exclude-backinstock,Apparel,apparel',
      display_on_policy_continue: false
    });
    klaviyo.enable("backinstock",{
    trigger: {
        product_page_text: "Sold out - Notify me when available",
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
     newsletter_subscribe_label: "Make sure I'm notified.",
     headline: "{product_name}",
     body_content: "Register to receive a notification when this item comes back in stock.",
     email_field_label: "Email",
     button_label: "Notify me when available",
     subscription_success_label: "You're in! We'll let you know when it's back.",
     footer_content: '',
     additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
     drop_background_color: "#000",
     background_color: "#fff",
     text_color: "#222",
     button_text_color: "#fff",
     button_background_color: "#2695f1",
     close_button_color: "#ccc",
     error_background_color: "#fcd6d7",
     error_text_color: "#C72E2F",
     success_background_color: "#d3efcd",
     success_text_color: "#1B9500"
    }
  });
  /*Klaviyo BIS script ends*/
(function() {
  
      CartJS.init(window.cart__json);
      InlineCart.init();
      Gift.init(window.current_template);
                $('body').addClass('promo_banner-show');
      // console.log ('added promo');
//       const $freeGiftModal =  $(".remodal--free-gift").remodal();
//       console.log($freeGiftModal)
      // Adding free gift items to the cart
      $(document).on('click','[free-gift-add]', function (e) {
        var btn = $(this);
        console.log(btn)
        e.stopImmediatePropagation();
        const $parentProductContainer = $(this).parent().parent();
        const selectedVariantId = $(this).parent().find('[free-gift-selection]').find("option:selected").val();
        console.log(selectedVariantId)

        CartJS.addItem(selectedVariantId, 1, {
          free_gift: true,
        }, {
          success: function (data) {
            console.log('product added');
            var product = data;
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: btn
              }
            }));
            if ($parentProductContainer) {
              $($parentProductContainer[0]).addClass('grid-product--selected');
            }
          }
        })
      })

      /*
    * When clicking on the checkout button, if the current cart has
    * no free gift items, show a modal that confirms if the user wants to
    * continue without a gift or not.
    */
      $(document).on('click', 'form[data-cart-form] [name="checkout"]', function(e) {
        e.preventDefault();

        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(data) {
            const $form = $('form[data-cart-form]');
            const totalAvailableGiftProduct = $('.drawer__free-gift > .grid-product').length
            const totalDisabledGiftProduct = $('.grid-product--disabled').length
			console.log(data.items)
            const countAddedFreeGiftsOnCart = data.items
            .filter(item => item.properties && item.properties.free_gift).length;

            const hasSubscription3 = data.items
            .filter(item => item.properties && item.properties.shipping_interval_frequency).length
            console.log((!hasSubscription3))
            if (countAddedFreeGiftsOnCart <= 0 && totalDisabledGiftProduct !== totalAvailableGiftProduct && !hasSubscription3) {
              return window.free_gift_remodal.open()
            }
            if (!hasSubscription3) {
              return $form.submit();
            }
          }
        })
       
      });
      
    // remove the button loading if the user chooses to pick a gift
      $(document).on('click', '.remodal--free-gift footer > .btn-pick-gift',() =>{
       $('[name="checkout"]').removeClass('btn--loading');
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent('cart:open'));
          $('.cart__scrollable').scrollTop($('.cart__scrollable')[0].scrollHeight);
        },300)
      });

      // continue form submit if the user chooses to have no gift
      
      $(document).on('click','.remodal--free-gift footer > .btn-no-gift', () =>{
        window.free_gift_remodal.close();
        const $form = $('form[data-cart-form]');return $form.submit();
     });  

    }());
    
    // Free gift options scripts
    